import { render, staticRenderFns } from "./LoadingCmp.vue?vue&type=template&id=1b2bc93c&scoped=true&"
import script from "./LoadingCmp.vue?vue&type=script&lang=js&"
export * from "./LoadingCmp.vue?vue&type=script&lang=js&"
import style0 from "./LoadingCmp.vue?vue&type=style&index=0&id=1b2bc93c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2bc93c",
  null
  
)

export default component.exports